import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CancelButton from '../CancelButton';
import { globalStyles as styles } from '../style/gstheme';

class Processing extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  cancel = () => {
    this.setState({ open: false });
    this.props.onCancel();
  };

  render() {

    const { classes } = this.props;

    return (
      <Dialog
        className={classes.dialog}
        data-test="processing"
        open={this.state.open}
        aria-labelledby="processing-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="processing-dialog-title">Processing</DialogTitle>
        <DialogContent>
            <DialogContentText className={classes.dialogText}>Please wait... your report is being generated.</DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CancelButton onClick={this.cancel}>Cancel Report</CancelButton>
        </DialogActions>
      </Dialog>
    );
  }
}

Processing.propTypes = {
  classes: PropTypes.object,
  onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(Processing);